import {
  GET_APPOINTMENT,
  GET_QUESTION_DETAILS,
  ADD_APPOINTMENT,
  UPDATE_APPOINTMENT,
  DELETE_APPOINTMENT,
} from "../Actions/actionTypes";
import _ from "lodash";
import sound from "../Sounds/oneToOne.mp3";
import { history } from "../store";
import { routeName } from "../Service/env";
import addNotification from "react-push-notification";
import { audioFunc } from "../Service/helper";

const initial = {
  results: {
    Appointment: [],
  },
};

export default (state = initial, action) => {
  switch (action.type) {
    case GET_APPOINTMENT:
      const appointmentCount = localStorage.getItem("appointmentCount");
      if (
        appointmentCount !== null &&
        appointmentCount !== "" &&
        appointmentCount !== "undefined"
      ) {
        if (action.payload && action.payload.length > appointmentCount) {
          audioFunc(false, false, sound);
          // var audio = new Audio();                     // create audio wo/ src
          // audio.preload = "auto";                      // intend to play through
          // audio.autoplay = true;                       // autoplay when loaded
          // audio.loop = false;
          // audio.muted = false;
          //
          // audio.src = sound; // just for example

          addNotification({
            title: "",
            message:
              action.payload.length - appointmentCount === 1
                ? "You have a new appointment!"
                : "You have new appointments!",
            theme: "red",
            native: !document.hasFocus() ? true : false, // true : "Browser Notification" , False "Custom Notification"
            backgroundTop: "#BF2129", //'#A534A6', //optional, background color of top container.
            backgroundBottom: "#d82c33", //'#b764ac', //optional, background color of bottom container.
            silent: true,
            duration: 17000,
            onClick: function () {
              console.log("reducer appointment");
              if (!document.hasFocus()) {
                window.focus();
                history.push(`/${routeName}/Dashboard/Appointments`);
                //this.close();
              }
            },
          });
        }
      }

      localStorage.setItem("appointmentCount", action.payload.length);

      return _.cloneDeep({ ...state, appointment: action.payload });
    case GET_QUESTION_DETAILS:
      return _.cloneDeep({ ...state, questionDetails: action.payload });
    case ADD_APPOINTMENT:
      return _.cloneDeep({ ...state, addAppointment: action.payload });
    case UPDATE_APPOINTMENT:
      return _.cloneDeep({ ...state, updateAppointment: action.payload });
    case DELETE_APPOINTMENT:
      return _.cloneDeep({ ...state, deleteAppointment: action.payload });
    default:
      return state;
  }
};
